import { DeviceType } from "src/app/shared/model/device-type";
import { SSNMaskingDefaultStrategy } from "./ssn-masking.default.strategy";
import { SSNMaskingTabletStrategy } from "./ssn-masking.tablet.strategy";


export const SSNMaskingStrategyMap = new Map<DeviceType, any>([
  [DeviceType.DEFAULT, SSNMaskingDefaultStrategy],
  [DeviceType.TABLET, SSNMaskingTabletStrategy],
  [DeviceType.MOBILE, SSNMaskingTabletStrategy]
]);
